export default __webpack_public_path__ + "static/media/4043279_afro_avatar_male_man_icon(1)@2x.25382c79.png";